module.exports = __webpack_public_path__ + "static/media/02.269c71f6.jpg";